import React from 'react';
import {parseEmbarkIFrameModalPayload} from 'shared/utils';

export interface IEmbarkIFrameModalSetters {
    setIsInsideEmbark: (isInsideEmbark: boolean) => void;
    setIsDarkMode: (isDarkMode: boolean) => void;
    setLocale: (locale: string) => void;
    setDesignToken: (designToken: Record<string, unknown>) => void;
    setDesignTokenDarkMode: (designTokenDarkMode: Record<string, unknown>) => void;
}

/**
 * Subscribes to the `embarkIFrameModal` postMessage for the lifetime of the calling
 * component, applying the validated/sanitized payload (see `parseEmbarkIFrameModalPayload`)
 * to the given state setters, and unsubscribes on unmount.
 *
 * Shared by every ERP provider (NetSuite, Intacct, QuickBooks, Xero) to stay in sync with
 * the parent Embark frame's theme/locale/dark-mode without duplicating the same handler
 * and effect in each one.
 */
export const useEmbarkIFrameModalMessage = ({
                                                setIsInsideEmbark,
                                                setIsDarkMode,
                                                setLocale,
                                                setDesignToken,
                                                setDesignTokenDarkMode,
                                            }: IEmbarkIFrameModalSetters): void => {
    React.useEffect(() => {
        const handleIFrameModalMessage = (event: MessageEvent) => {
            const payload = parseEmbarkIFrameModalPayload(event);
            if (payload === null) {
                return;
            }
            setIsInsideEmbark(payload.isEmbark);
            setIsDarkMode(payload.isDarkMode);
            setLocale(payload.locale);
            setDesignToken(payload.designToken);
            setDesignTokenDarkMode(payload.designTokenDarkMode);
        };

        window.addEventListener('message', handleIFrameModalMessage);
        return () => {
            window.removeEventListener('message', handleIFrameModalMessage);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};